(function() {
  'use strict';

  angular.module('app').factory('TerminalService', TerminalService);

  TerminalService.$inject = ['$rootScope', 'API', 'NotifyService'];

  function TerminalService($rootScope, API, NotifyService) {
    var service = {};

    /**
     * This callback type is called `requestCallback` and is displayed as a global symbol.
     *
     * @callback requestCallback
     * @param {boolean} success
     * @param {Object} data
     */
    /**
     * @typedef MultiLanguageObject
     * @type {Object}
     * @property {string} en - String on English
     * @property {string} pl - String on Polish
     * @property {string} ru - String on Russian
     * @property {string} uk - String on Ukrainian
     */

    $rootScope.$on('user-logout', function() {
      $rootScope.TERMINALS = null;
    });

    /**
     * Return list of Terminals assigned with point of sales id
     *
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.All = function(callback) {
      API.get('/terminal', function(success, data) {
        if (success) {
          $rootScope.TERMINALS = data;
        }
        callback(success, data);
      });
    };

    /**
     * Return list of Terminals assigned with point of sales ID
     *
     * @param {string} posID - Point of sales ID.
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.forPOS = function(posID, callback) {
      API.get('/pos/' + posID + '/terminals', function(success, data) {
        if (success) {
          //
        }
        callback(success, data);
      });
    };


    /**
     * Return Terminal info
     *
     * @param {string} terminalID - Terminal ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.Get = function(terminalID, callback) {
      API.get('/terminal/' + terminalID, function(success, data) {
        if (success) {
          updateItemInList($rootScope.TERMINALS, data);
        }
        callback(success, data);
      });
    };

    /**
     * Return Terminal monitoring journal
     *
     * @param {string} terminalID - Terminal ID
     * @param {object} params -
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetMonitoringJournal = function(terminalID, params, callback) {
      API.get('/terminal/' + terminalID +'/events/statuses'+ (params ? ('?' + paramsToUrlQueryEncodeURIComponent(params)) : ''), function(success, data) {
        if (success) {
          console.log("datadatadatadatadata",data)
        }
        callback(success, data);
      });
    };

    /**
     * Add new Terminal. ID of Point of sales (POS) used from post data
     *
     * @param {object} post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.Create = function(post_data, callback) {
      API.post('/terminal', post_data, function(success, data) {
        if (success) {
          NotifyService.Success(data.message, false);
        }
        callback(success, data);
      });
    };

    /**
     * Change exist Terminal info
     *
     * @param {string} terminalID - Terminal ID.
     * @param {object} post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.Change = function(terminalID, post_data, callback) {
      API.patch('/terminal/' + terminalID, post_data, function(success, data) {
        if (success) {
          updateItemInList($rootScope.TERMINALS, data);
          NotifyService.Success(data.message, false);
        }
        callback(success, data);
      });
    };

    /**
     * Generate ibeacon for terminal and return Terminal info
     *
     * @param {string} terminalID - Terminal ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.iBeacon = function(terminalID, callback) {
      API.get('/terminal/{0}/generate_ibeacon'.format(terminalID), function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Generate new api key and return Terminal info
     *
     * @param {string} terminalID - Terminal ID
     * @param {requestCallback} callback - The callback that handles the response.
     * @constructor
     */
    service.APIKey = function(terminalID, callback) {
      API.get('/terminal/{0}/update_apikey'.format(terminalID), function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Get terminal additional costs list
     *
     * @param {string} terminalID - Terminal ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetAdditionalCosts = function(terminalID, callback) {
      API.get('/terminal/{0}/additional_costs'.format(terminalID), function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Set terminal additional costs list
     *
     * @param {string} terminalID - Terminal ID
     * @param {object} post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateAdditionalCosts = function(terminalID, post_data, callback) {
      API.patch('/terminal/{0}/additional_costs'.format(terminalID), post_data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return list of terminal additional costs for goods items
     *
     * @param {string} terminalID - Terminal ID
     * @param {object} params -
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetAdditionalCostsItems = function(terminalID, params, callback) {
      API.get(
          '/terminal/{0}/additional_costs/items'.format(terminalID) + (params ? ('?' + paramsToUrlQueryEncodeURIComponent(params)) : ''),
          function(success, data) {
            callback(success, data);
          });
    };

    /**
     * Modify additional costs for items and return list of terminal additional costs for goods items
     *
     * @param {string} terminalID - Terminal ID
     * @param {object} post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateAdditionalCostsItems = function(terminalID, post_data, callback) {
      API.patch('/terminal/{0}/additional_costs/items'.format(terminalID), post_data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return additional costs for goods item
     *
     * @param {string} terminalID - Terminal ID
     * @param {string} itemID - Item ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetAdditionalCostsItem = function(terminalID, itemID, callback) {
      API.get('/terminal/' + terminalID + '/additional_costs/items/' + itemID, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Modify additional costs for goods item
     *
     * @param {string} terminalID - Terminal ID
     * @param {string} itemID - Item ID
     * @param {object} post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateAdditionalCostsItem = function(terminalID, itemID, post_data, callback) {
      API.patch('/terminal/' + terminalID + '/additional_costs/items/' + itemID, post_data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Get list of business staff who get access
     *
     * @param {string} terminalID - Terminal ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetStaff = function(terminalID, callback) {
      API.get('/terminal/' + terminalID + '/staff', function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Delete business staff who get access
     *
     * @param {string} terminalID - Terminal ID
     * @param {object} post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.DeleteAccessStaff = function(terminalID, post_data, callback) {
      API.delete('/terminal/' + terminalID + '/staff', post_data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Add business staff who get access
     *
     * @param {string} terminalID - Terminal ID
     * @param {object} post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.AddStaff = function(terminalID, post_data, callback) {
      API.post('/terminal/' + terminalID + '/staff', post_data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return goods items for terminal
     *
     * @param {string} terminalID - Terminal ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetTerminalGoods = function(params, terminalID, callback) {
      API.get('/terminal/' + terminalID + '/goods?' + paramsToUrlQueryEncodeURIComponent(params), function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return Poster settings for terminal
     *
     * @param {string} terminalID - Terminal ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetPosterSettings = function(terminalID, callback) {
      API.get('/terminal/' + terminalID + '/settings/poster', function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Modify Poster settings for terminal
     *
     * @param {string} terminalID - Terminal ID
     * @param {object} post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdatePosterSettings = function(terminalID, post_data, callback) {
      API.patch('/terminal/' + terminalID + '/settings/poster', post_data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return list of available Poster applications
     *
     * @param {string} terminalID - Terminal ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetPosterApplications = function(terminalID, callback) {
      API.get('/terminal/' + terminalID + '/settings/poster/applications', function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return Application settings for terminal
     *
     * @param {string} terminalID - Terminal ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetApplicationSettings = function(terminalID, callback) {
      API.get('/terminal/' + terminalID + '/settings/application', function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Modify Application settings for terminal
     *
     * @param {string} terminalID - Terminal ID
     * @param {object} post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateApplicationSettings = function(terminalID, post_data, callback) {
      API.patch('/terminal/' + terminalID + '/settings/application', post_data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Modify External devices Pax settings for terminal
     *
     * @param {string} terminalID - Terminal ID
     * @param {object} post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateExternalDevicesPaxSettings = function(terminalID, post_data, callback) {
      API.patch('/terminal/' + terminalID + '/settings/external_devices/pax', post_data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return External devices Pax settings for terminal
     *
     * @param {string} terminalID - Terminal ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetExternalDevicesPaxSettings = function(terminalID, callback) {
      API.get('/terminal/' + terminalID + '/settings/external_devices/pax', function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Modify External devices Amp settings for terminal
     *
     * @param {string} terminalID - Terminal ID
     * @param {object} post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateExternalDevicesAmpSettings = function(terminalID, post_data, callback) {
      API.patch('/terminal/' + terminalID + '/settings/external_devices/amp', post_data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return External devices Amp settings for terminal
     *
     * @param {string} terminalID - Terminal ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetExternalDevicesAmpSettings = function(terminalID, callback) {
      API.get('/terminal/' + terminalID + '/settings/external_devices/amp', function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return notifications settings for terminal
     *
     * @param {string} terminalID - Terminal ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetNotificationsSettings = function(terminalID, callback) {
      API.get('/terminal/' + terminalID + '/notifications/settings', function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Modify notifications settings for terminal
     *
     * @param {string} terminalID - Terminal ID
     * @param {object} post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateNotificationsSettings = function(terminalID, post_data, callback) {
      API.patch('/terminal/' + terminalID + '/notifications/settings', post_data, function(success, data) {
        callback(success, data);
      });
    };

    return service;
  }

})();
